import React from 'react';
import {
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast';
import { DEFAULT_DURATION, useToast } from '@/core/hooks/useToast';

/**
 * Renders the live toast queue. Mounted once, inside <ToastStore>.
 */
export const Toaster: React.FC = () => {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider swipeDirection="right">
      {toasts.map(({ id, title, description, variant, duration, action }) => {
        const configured = duration ?? DEFAULT_DURATION[variant ?? 'default'];
        // Radix clamps a non-finite duration to 0, which would dismiss
        // instantly. "Persistent" is expressed as an hour.
        const resolved = Number.isFinite(configured) ? configured : 60 * 60 * 1000;
        return (
          <Toast
            key={id}
            variant={variant}
            duration={resolved}
            onOpenChange={(open) => {
              if (!open) dismiss(id);
            }}
          >
            <div className="grid gap-1">
              <ToastTitle>{title}</ToastTitle>
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action && (
              <ToastAction
                altText={action.label}
                onClick={() => {
                  action.onClick();
                  dismiss(id);
                }}
              >
                {action.label}
              </ToastAction>
            )}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
